<template>
  <parent>
    <loading-page v-if="loading" />
    <div
      v-else
      class="general h-100"
    >
      <div class="d-flex flex-column p-1">
        <div class="row mt-1">
          <input-field
            label="Project Name"
            label-position="top"
            class="px-1 col-12 col-md-6"
          >
            <span class="text-lg">{{ project.name }}</span>
          </input-field>
          <input-field
            label="Organization ID"
            label-position="top"
            class="px-1 col-12 col-md-6"
          ><a
            v-clipboard:copy="project.organizationId"
            v-clipboard:success="copySuccess"
            class="text-lg"
          >
            {{ project.organizationId }}
            <GjIcon
              name="Copy"
              size="20"
            /></a>
          </input-field>
        </div>
        <div class="row mt-1">
          <input-field
            label="Project ID"
            label-position="top"
            class="px-1 col-12 col-md-6"
          ><a
            v-clipboard:copy="project.id"
            v-clipboard:success="copySuccess"
            class="text-lg"
          >
            {{ project.id }}
            <GjIcon
              name="Copy"
              size="20"
            /></a>
          </input-field>
        </div>
      </div>
      <span class="bg-icon">
        <GjIcon
          name="Settings"
          size="140"
        />
      </span>
    </div>
  </parent>
</template>
<script>
import redirectError from '@/services/redirectError'

export default {
  name: 'General',
  data() {
    return {
      fields: ['id', 'name'],
    }
  },
  computed: {
    project() {
      return this.$store.state.projects.project
    },
    loading() {
      return this.$store.state.projects.gettingProject
    },
  },
  created() {
    this.$store
      .dispatch('projects/getProject')
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
}
</script>
<style lang="scss" scoped>
.inner-paper::v-deep {
  .card-header {
    padding: 16px 0;
  }
}
</style>
